import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported as analyticsIsSupported, logEvent } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { isSupported as messagingIsSupported, getMessaging } from "firebase/messaging";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDptMS51bB06TpfuDqh62WW0-n79xT2uTU",
  authDomain: "qrzone-menuvivo.firebaseapp.com",
  projectId: "qrzone-menuvivo",
  storageBucket: "qrzone-menuvivo.firebasestorage.app",
  messagingSenderId: "995856566219",
  appId: "1:995856566219:web:b612732716e1492833584e"
};

const app = initializeApp(firebaseConfig);
window.__FIREBASE_APP__ = app;

// ─────────────────────────────
// GOOGLE ANALYTICS CON CONSENSO
// ─────────────────────────────

let analytics = null;
let analyticsInitializing = false;

export async function enableAnalytics() {
  // Evita inizializzazioni multiple
  if (analytics || analyticsInitializing) {
    return analytics;
  }

  analyticsInitializing = true;

  try {
    const yes = await analyticsIsSupported();

    if (!yes) {
      console.warn("⚠️ Google Analytics non supportato su questo browser");
      return null;
    }

    analytics = getAnalytics(app);

    logEvent(analytics, "qrmenu_site_open", {
      platform: "web",
    });

    console.log("📊 Google Analytics attivo con consenso");

    return analytics;
  } catch (err) {
    console.warn("⚠️ Inizializzazione Google Analytics fallita:", err);
    return null;
  } finally {
    analyticsInitializing = false;
  }
}

// Se l'utente aveva già accettato in una visita precedente,
// riattiva Analytics automaticamente
if (typeof window !== "undefined") {
  const cookieConsent = localStorage.getItem("qrmenu_cookie_consent");

  if (cookieConsent === "accepted") {
    enableAnalytics();
  }
}

export { analytics };

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west1");
export const functionsUS = getFunctions(app, "us-central1");

// ─────────────────────────────
// FIREBASE MESSAGING SICURO
// ─────────────────────────────

let messaging = null;

messagingIsSupported()
  .then((yes) => {
    if (yes) {
      messaging = getMessaging(app);
      console.log("🔔 Firebase Messaging attivo");
    } else {
      console.warn("⚠️ Firebase Messaging non supportato su questo browser");
    }
  })
  .catch((err) => {
    console.warn("⚠️ Controllo Firebase Messaging fallito:", err);
  });

export { messaging };